export enum FileType {
  Pdf = 'pdf',
  Word = 'word',
  Excel = 'excel',
  Powerpoint = 'powerpoint'
}

export class FileExtensions {
  static Pdf = ['pdf'];
  static Word = ['doc', 'docx'];
  static Excel = ['xls', 'xlsx'];
  static Powerpoint = ['ppt', 'pptx'];
}

export const getFileIcon = (ext: string): string => {
  const type: string = Object.keys(FileExtensions).find((key) =>
    FileExtensions[key].includes(ext)
  );
  return type ? `file-${FileType[type]}` : 'file';
};
